import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button, Modal, Spinner,
  FormGroup, Label, Input, NavLink, Col, ModalBody, ModalFooter
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import auth from "authProvider";
import ModalImage from "react-modal-image";
import Scrollbars from 'react-custom-scrollbars';


const Feedback = (props) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [feedback, setfeedback] = useState(false);
  const [position, setPosition] = useState(false);
  const [openorderedit, setOpenorderedit] = useState(false)
  const [viewfeedback, setviewfeedback] = useState(false)
  const [technicianslct, setTechnicianslct] = useState([]);
  const [openservice, setOpenservice] = useState(false)
  const [technicians, setTechnicians] = useState(false);

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const onSubmit_update = (values) => {
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('review', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setfeedback(data);
      })
    dataProvider.getList('technicians', { params: { pagination: { page: 1, perPage: 500 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setTechnicians(data) })
      .catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }, [props, reload]);

  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  const Openorderedit = (index, id) => {
    setPosition(index)
    if (!id) {
      return;
    }
    dataProvider.getOrderView({ id: feedback[index]?.orderId?.id }).then(({ data }) => {
      setviewfeedback(data);
    })
    setOpenorderedit(true);
  }

  const orderClose = () => {
    setOpenorderedit(false);
    window.location.reload()
  };
  const opendropdowntechnician = () => {
    setOpenservice(!openservice)
  }
  // if (!viewfeedback) {
  //   return (
  //     <>
  //       <div >
  //         <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
  //       </div>
  //     </>
  //   )
  // }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', paddingLeft: '20px' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', textTransform: 'uppercase' }}>FEEDBACK</h1>
            </Row>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start' }}><h2 style={{ fontSize: '1rem', fontWeight: 'bold' }} className="mb-0">FEEDBACKS</h2></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col" style={{ fontSize: '0.65rem', color: '#7e8190' }}>USER NAME</th>
                    <th scope="col" style={{ paddingLeft: '8rem', fontSize: '0.65rem', color: '#7e8190' }}>FEEDBACK</th>
                    <th scope="col" style={{ display: 'flex', justifyContent: 'center', fontSize: '0.65rem', color: '#7e8190' }}>WORKORDER</th>
                  </tr>
                </thead>
                <tbody>
                  {!feedback || feedback.length < 1 ? (
                    <tr>
                      <td style={{ color: '#12ACF6', textAlign: 'center', padding: 20, margin: 20 }} colSpan={11}>No Results Found
                        <IcomoonReact style={{ marginLeft: 10 }} iconSet={iconSet} color="#12ACF6" size={22} icon="search" />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {feedback.map((item, index) => (
                        <tr>
                          {item?.rating === 1 ? (<td style={{ width: '100px', height: '50px' }}><img src={require('../../../assets/img/brand/emo-1.png').default} style={{ maxWidth: '100%' }} alt="..." /></td>) :
                            item?.rating === 2 ? (<td style={{ width: '100px', height: '50px' }}><img src={require('../../../assets/img/brand/emo-2.png').default} className="img-fluid" alt="..." /></td>) :
                              item?.rating === 3 ? (<td style={{ width: '50px', height: '50px' }}><img src={require('../../../assets/img/brand/emo-3.png').default} className="img-fluid" alt="..." /></td>) :
                                item?.rating === 4 ? (<td style={{ width: '100px', height: '50px' }}><img src={require('../../../assets/img/brand/emo-4.png').default} className="img-fluid" alt="..." /></td>) :
                                  <td style={{ width: '100px', height: '50px' }}><img className="img-fluid" alt="..." /></td>
                          }
                          <td style={{ color: '#c7c0c5' }}>{item?.tenantId?.username} </td>
                          <td style={{ padding: 25 }}>
                            {item?.rating === 1 ? (<div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 5, backgroundColor: '#edf5f8', width: '100%', display: 'flex', flexDirection: 'column' }}><span style={{ color: '#04426b', fontWeight: 'bold', fontSize: '0.75rem' }}>BAD</span><span style={{ color: '#04426b' }}></span></div>) :
                              item?.rating === 2 ? (<div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 5, backgroundColor: '#edf5f8', width: '100%', display: 'flex', flexDirection: 'column' }}><span style={{ color: '#04426b', fontWeight: 'bold', fontSize: '0.75rem' }}>GOOD</span><span style={{ color: '#04426b' }}></span></div>) :
                                item?.rating === 3 ? (<div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 5, backgroundColor: '#edf5f8', width: '100%', display: 'flex', flexDirection: 'column' }}><span style={{ color: '#04426b', fontWeight: 'bold', fontSize: '0.75rem' }}>VERY GOOD</span><span style={{ color: '#04426b' }}></span></div>) :
                                  item?.rating === 4 ? (<div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 5, backgroundColor: '#edf5f8', width: '100%', display: 'flex', flexDirection: 'column' }}><span style={{ color: '#04426b', fontWeight: 'bold', fontSize: '0.75rem' }}>EXCELLENT</span><span style={{ color: '#04426b' }}></span></div>) :
                                    <div style={{ border: '1px solid #ccc', padding: 12, borderRadius: 5, backgroundColor: '#edf5f8', width: '100%' }}><span style={{ color: '#04426b', fontWeight: 'bold' }}></span>  </div>}
                          </td>
                          <td style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button onClick={() => Openorderedit(index, feedback[index]?.orderId?.id ? feedback[index]?.orderId?.id : null)} disabled={loading === 1} type="submit" style={{ backgroundColor: loading === 1 ? 'green' : '#55c1eb', fontSize: '0.6rem', border: 0, color: 'white', borderRadius: '20px', marginTop: 10, padding: '7px 22px 7px 22px' }}>
                              VIEW</Button>{' '}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={openorderedit}
          style={{
            maxWidth: '700px',
          }}
        >
          <div onClick={orderClose} style={{ backgroundColor: 'rgb(193 193 124)', width: '30px', height: '30px', position: 'absolute', right: '-6px', top: '-10px', borderRadius: '50%', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={orderClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div className="modal-header" style={{ backgroundColor: 'rgb(5 160 187)', flexDirection: 'column', display: 'flex', padding: '8px' }} >
            <h2 style={{ marginTop: '20px', marginLeft: 30, color: 'white', textTransform: 'uppercase' }} className="modal-title" id="exampleModalLabel">
              {viewfeedback?.serviceId?.title}
            </h2>
            <h3 style={{ marginTop: '20px', marginLeft: 30, color: 'white', fontSize: '0.8rem', marginTop: 5 }}>
              <label style={{ color: 'rgb(128 207 209)' }}>created on {viewfeedback?.created_on}</label>
            </h3>
          </div>
          <div>
            <Scrollbars
              renderThumbVertical={props => < div {...props} className="thumb-vertical" />}
              renderTrackVertical={props => < div {...props} className="track-vertical" />}
              renderThumbHorizontal={props => < div {...props} />}
              style={{ height: 430 }}>
              <Form
                onSubmit={onSubmit_update}
                render={({ handleSubmit }) => (
                  <form
                    onSubmit={handleSubmit} style={{ padding: '10px' }}>

                    <div className="pl-lg-4">
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%' }}>
                        <Col lg="5" style={{ width: '40%' }}>
                          <div style={{ width: 'maxContent', marginBottom: 20 }}>
                            <div style={{
                              border: '1px solid rgb(0 139 183)',
                              height: '60px',
                              borderRadius: '5px',
                              margin: 0,
                              overflow: 'hidden',
                            }} >
                              <div onClick={() => opendropdowntechnician()} style={{ display: 'flex', marginLeft: 10, marginTop: 5 }}>
                                <div style={{ border: '1px solid rgb(0 139 183)', width: 30, borderRadius: '50%', height: 30, marginTop: 8 }}>
                                  <IcomoonReact style={{ marginLeft: 5 }} iconSet={iconSet} color="rgb(14 145 186)" size={20} icon="assigned-technician" />
                                </div>
                                {technicianslct && technicianslct.length > 0 || viewfeedback?.technicianIds && viewfeedback?.technicianIds.length > 0 ?
                                  <div><label style={{ fontSize: '0.6rem', marginLeft: 10 }}>ASSIGNED</label></div> :
                                  <div><label style={{ fontSize: '0.6rem', marginLeft: 10 }}>NOT ASSIGNED</label></div>}
                              </div>
                              <div onClick={() => opendropdowntechnician()} style={{ display: 'flex', marginLeft: 40, marginTop: '-10px' }}>
                                {viewfeedback.technicianIds && viewfeedback.technicianIds.length > 0 ? (
                                  viewfeedback.technicianIds.map((item, index) => (
                                    <div type="text" id=""
                                      style={{
                                        width: '200px',
                                        backgroundColor: 'transparent',
                                        color: 'rgb(0 139 183)',
                                        padding: '0px',
                                        marginLeft: 10,
                                        display: 'inline-block',
                                        outline: 'none',
                                        border: 'none',
                                        fontSize: '0.8rem',
                                        whiteSpace: 'nowrap',
                                        fontWeight: 600
                                      }}>{item?.fullname}</div>
                                  ))
                                ) : (
                                  <div style={{
                                    width: '100%',
                                    backgroundColor: 'transparent',
                                    color: 'rgb(0 139 183)',
                                    padding: '0px',
                                    outline: 'none',
                                    border: 'none',
                                    fontSize: '0.8rem',
                                    paddingLeft: 6
                                  }}></div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="3" style={{ display: 'flex', flexDirection: 'column' }}>
                          <label style={{ fontSize: '0.6rem', textTransform: 'uppercase', marginLeft: 20 }}>status</label>
                          <div style={{ display: 'flex', marginLeft: 20 }}>
                            <div>
                              <span class="badge-dot badge ">
                                <i class={(viewfeedback?.status === 'completed') ? 'bg-success' : 'bg-danger'}></i>
                              </span>
                            </div>
                            <div>
                              <label style={{
                                color: viewfeedback?.status === 'completed' ? 'green' : 'red',
                                border: '1px solid transparent',
                                backgroundColor: '#fff',
                                paddingBottom: 25,
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                fontSize: '0.8rem'
                              }}>
                                {viewfeedback?.status}
                              </label>
                            </div>
                          </div>
                        </Col>
                        <Col md="4" style={{ display: 'flex', flexDirection: 'column' }}>
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Date & Time </label>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{viewfeedback?.availabilityId?.title ? viewfeedback?.availabilityId?.title : null}</label>
                            <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{viewfeedback?.time && viewfeedback?.time !== 'null' ? viewfeedback?.time : null}</label>
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%' }}>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>order id</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem', color: 'rgb(13 151 207)' }}>{viewfeedback?.orderId ? viewfeedback?.orderId : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>categories</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.8rem', color: 'rgb(13 151 207)' }}>{viewfeedback?.categoryId?.category ? viewfeedback?.categoryId?.category : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>place</label>
                          <div style={{ color: 'rgb(13 151 207)' }}>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.8rem', color: 'rgb(13 151 207)' }}>{viewfeedback?.placeId?.category?.area ? viewfeedback?.placeId?.category?.area : null}</label>-
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.8rem', color: 'rgb(13 151 207)' }}>{viewfeedback?.placeId?.area ? viewfeedback?.placeId?.area : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>service</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.8rem', color: 'rgb(13 151 207)' }}>{viewfeedback?.serviceId?.title ? viewfeedback?.serviceId?.title : null}</label>
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%' }}>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>description</label>
                          <div>
                            <label style={{ color: 'black', textTransform: 'uppercase', fontSize: '0.9rem', color: 'rgb(13 151 207)', fontWeight: 600 }}>{viewfeedback.description !== 'undefined' ? viewfeedback.description : 'No description'}</label>
                          </div>
                        </Col>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>photos</label>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {viewfeedback.photos && viewfeedback.photos.length > 0 && (
                              viewfeedback.photos.map((item, index) => (
                                <div style={{ margin: 10, overflow: 'hidden', borderRadius: 5 }}>
                                  <ModalImage
                                    className="image-bgsize"
                                    small={item}
                                    large={item}
                                    hideDownload={true}
                                    hideZoom={true}
                                  />
                                </div>
                              )))}
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', padding: '10px 0px 10px 0px', width: '100%' }}>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Location</label>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div>
                              <IcomoonReact iconSet={iconSet} style={{ paddingLeft: 2 }} color="rgb(15 145 187)" size={14} icon="loations" />
                            </div>
                            <div style={{ marginLeft: 8 }}>
                              <label style={{ color: 'rgb(112 117 100)', textTransform: 'uppercase', fontSize: '0.9rem' }}>
                                <label style={{ color: 'rgb(13 151 207)', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem' }}>{viewfeedback?.sub_locationId?.location ? viewfeedback?.sub_locationId?.location : null + ',' + viewfeedback?.locationId?.location ? viewfeedback?.locationId?.location : null}</label>
                              </label>
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>priority</label>
                          <div style={{ width: '7rem', height: '1.8rem', backgroundColor: '#f9cfcf', border: 'none', boxShadow: 'none', borderRadius: '10px' }}>
                            <label style={{ color: 'rgb(245 57 60)', fontSize: '0.6rem', fontWeight: 'bold', paddingLeft: '28px', textTransform: 'uppercase' }}>
                              {viewfeedback?.priorityId?.priority}</label>
                          </div>
                        </Col>
                      </Row>
                      {viewfeedback.productIds && viewfeedback.productIds.length > 0 ?
                        <Table size="sm" style={{ width: '87%', marginTop: '20px' }} >
                          <thead>
                            <tr style={{ backgroundColor: 'rgb(242 242 242)' }}>
                              <th>PARTS NAME</th>
                              <th>QTY</th>
                              <th>PRICE</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewfeedback.productIds && viewfeedback.productIds.length > 0 && (
                              viewfeedback.productIds.map((item, index) => (
                                <>
                                  <tr style={{ border: '1px solid #ccc' }}>
                                    <td style={{ color: '#044058', fontWeight: 'bold' }}>{item.name}</td>
                                    <td>
                                      <div>
                                        <span style={{ fontWeight: 'bold', fontSize: '0.7rem', textAlign: 'center' }}>{item.count}</span>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <span style={{ fontWeight: 'bold', fontSize: '0.7rem', textAlign: 'center' }}>{item.count * item.price}</span>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )))}
                          </tbody>
                        </Table>
                        : null}
                      <Row>
                        <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 30 }}>COMMENTS</label>
                        <Col md="11">
                          <FormGroup>
                            <Field name="comments" initialValue={viewfeedback?.comments ? viewfeedback?.comments : null}>
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ padding: 15, backgroundColor: '#efefef', color: 'black' }}
                                    disabled
                                    type="textarea"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      {viewfeedback?.comments && (
                        <>
                          <Row>
                            <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10 }}>ADDITIONAL COMMENTS</label>
                            <Col md="11">
                              <FormGroup>
                                <Field name="additional_comments" initialValue={viewfeedback?.additional_comments ? viewfeedback?.additional_comments : null} >
                                  {({ input, meta }) => (
                                    <div>
                                      <Input
                                        style={{ padding: 15, backgroundColor: '#efefef', color: 'black' }}
                                        {...input}
                                        disabled
                                        type="textarea"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10, textTransform: 'uppercase' }}>Parts Comments</label>
                            <Col md="11">
                              <FormGroup>
                                <Field name="parts_comments" initialValue={viewfeedback?.parts_comments ? viewfeedback?.parts_comments : null}>
                                  {({ input, meta }) => (
                                    <div>
                                      <Input
                                        style={{ padding: 15, backgroundColor: '#efefef', color: 'black' }}
                                        {...input}
                                        disabled
                                        type="textarea"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Col md="6" >
                        <Button onClick={orderClose} disabled={loading} color={'white'} type="submit" style={{ backgroundColor: 'rgb(20 150 180)', width: '80%', color: 'white', borderRadius: '50px', boxShadow: 'none', padding: 10, marginBottom: '20px', textAlign: 'center', marginTop: 20 }} >
                          {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                          DONE</Button>{' '}
                      </Col>
                    </div>
                  </form>
                )}
              />
            </Scrollbars>
          </div>
        </Modal>
      </div>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Feedback;
